import type { Scenario } from "../entities";
import { migrebotScenario } from "./migrebot";
import { sleepScenario } from "./sleep";

export { migrebotScenario, MIGREBOT_SCENARIO_ID } from "./migrebot";
export { sleepScenario, SLEEP_SCENARIO_ID } from "./sleep";

export const builtInScenarios: Scenario[] = [migrebotScenario, sleepScenario];

/** Returns human-readable problems; an empty array means the scenario is consistent. */
export function validateScenario(scenario: Scenario): string[] {
  const errors: string[] = [];
  const seen = new Set<string>();
  for (const q of scenario.questions) {
    if (seen.has(q.id)) errors.push(`duplicate question id "${q.id}"`);
    if (q.showIf && !seen.has(q.showIf.questionId)) {
      errors.push(`question "${q.id}": showIf refers to unknown or later question "${q.showIf.questionId}"`);
    }
    if (q.type === "scale" && q.min >= q.max) errors.push(`question "${q.id}": scale min must be below max`);
    if (q.type === "single" || q.type === "multi") {
      const optionIds = new Set<string>();
      for (const o of q.options) {
        if (optionIds.has(o.id)) errors.push(`question "${q.id}": duplicate option id "${o.id}"`);
        optionIds.add(o.id);
      }
    }
    seen.add(q.id);
  }
  if (scenario.episodes && !seen.has(scenario.episodes.gateQuestionId)) {
    errors.push(`episodes: unknown gate question "${scenario.episodes.gateQuestionId}"`);
  }
  const marker = scenario.calendarMarker;
  if (marker && !seen.has(marker.questionId)) errors.push(`calendarMarker: unknown question "${marker.questionId}"`);
  if (marker?.intensityQuestionId && !seen.has(marker.intensityQuestionId)) {
    errors.push(`calendarMarker: unknown intensity question "${marker.intensityQuestionId}"`);
  }
  if (marker?.highlightQuestionId && !seen.has(marker.highlightQuestionId)) {
    errors.push(`calendarMarker: unknown highlight question "${marker.highlightQuestionId}"`);
  }
  return errors;
}
